import { render, staticRenderFns } from "./CrearClienteModal.vue?vue&type=template&id=02b4f494&"
import script from "./CrearClienteModal.vue?vue&type=script&lang=ts&"
export * from "./CrearClienteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports